import { Details } from '@mui/icons-material';
import { createContext, useState, useEffect, useContext } from 'react';

export const RestrictionsMainDataContext = createContext();
export const RowDataContext = createContext(); // This is for row data of product restriction table
export const RatePlanRowDataContext = createContext(); // This is for row data of product restriction table
export const RowStateContext = createContext(); // This is for row data of product restriction table
export const RestrictionsStateContext = createContext(); // This is for row data of product restriction table

export const RowStateProvider = ({ children, value }) => {
    const [dataValue, setDataValue] = useState(value);
    const updateState = (newState) => {
        setDataValue((state) => ({
            ...state,
            ...newState
        }));
    };
    useEffect(() => {
        setDataValue(value);
    }, [value]);
    return (
        <RowStateContext.Provider value={{ state: dataValue, updateState }}>
            {children}
        </RowStateContext.Provider>
    );
}

export const RestrictionsMainDataProvider = ({ children, value }) => {
    value.bucket_update = 0;
    let [dataValue, setDataValue] = useState(value);
    const updateData = (newData) => {
        dataValue = newData;
        setDataValue(() => {
            return newData;
        });
    };

    return (
        <RestrictionsMainDataContext.Provider value={{ data: dataValue, updateData }}>
            {children}
        </RestrictionsMainDataContext.Provider>
    );
}
export const RowDataProvider = ({ children, value }) => {
    value.bucket_update = 0;
    const [dataValue, setDataValue] = useState(value);
    const mainData = useContext(RestrictionsMainDataContext);
    const updateRowData = (newData) => {
        // debugger;
        setDataValue((prevData) => {
            return ({
                ...prevData,
                ...newData
            })
        });
    };
    useEffect(() => {
        setDataValue((prevData) => {
            return ({
                ...prevData,
                buckets: value.buckets,
            })
        });
    }, [value.buckets]);

    useEffect(() => {
        setDataValue((prevData) => {
            return ({
                ...prevData,
                ...value,
                details_open: false,
                buckets: value.buckets,
            })
        });
    }, [value.date]);

    return (
        <RowDataContext.Provider value={{ data: dataValue, updateRowData }}>
            {children}
        </RowDataContext.Provider>
    );
}

export const BucketDataProvider = ({ children, value }) => {
    const [dataValue, setDataValue] = useState(value);
    const updateBucketData = (newData) => {
        setDataValue((prevData) => ({
            ...prevData,
            buckets: newData.buckets || prevData.buckets,
        }));
    };
    return (
        <RatePlanRowDataContext.Provider value={{ data: dataValue, updateBucketData }}>
            {children}
        </RatePlanRowDataContext.Provider>
    );
}

export const RestrictionsStateProvider = ({ children, value }) => {
    const [dataValue, setDataValue] = useState(value);
    const updateState = (newData) => {
        setDataValue((prevData) => ({
            ...prevData, ...newData
        }));
    };
    return (
        <RestrictionsStateContext.Provider value={{ state: dataValue, updateState }}>
            {children}
        </RestrictionsStateContext.Provider>
    );
}

